import { AfterViewChecked, AfterViewInit, Component, OnChanges, OnInit, Pipe, Renderer2, SimpleChanges } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { AdminApi } from "../models/admin-api";
import { ThemePalette } from '@angular/material/core';
import { DomSanitizer, EventManager } from '@angular/platform-browser';
import { EncryptDecryptService } from '../services/encrypt-decrypt.service';
import { ConfigService } from '../services/config.service';
import { from, Observable, of } from 'rxjs';
declare var $: any;

const optionRequete = {
  headers: new HttpHeaders({
    //'Access-Control-Allow-Origin':'*',
    'responseType': 'plain/text'
  })
};

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit, AfterViewInit, OnChanges {
  apikey: string;
  color: ThemePalette = 'primary';
  colorBis: ThemePalette = 'primary';
  public isMobile = false;
  public annonces: AnnonceLite[] = [];
  homeInfos: any;
  charger = false;
  config = ConfigService.GetItem;

  baseCards = ConfigService.dyns;

  actualCards: number[] = [];

  slides: Slider[] = [{
    content: '« Rhprofiler au quotidien, c’est un gain de temps non négligeable pour traiter l’ensemble des CV reçus mais également pour surveiller la mise en ligne des nombreuses annonces que je passe. En un coup d’œil sur mon interface, j’ai une visibilité sur le nombre de CV qu’il me reste à traiter, sur les annonces que je dois mettre ou remettre en ligne ou encore sur le nombre de réponses que je dois faire aux candidats.',
    img: 'https://www.rhprofiler.com/wp-content/uploads/2019/03/temoignage-cer-226x226.jpg',
    name: 'Vincent Richard',
    poste: 'DRH'
  },
  {
    content: '« Nous sommes un réseau de restaurants qui implique une multitude d’interlocuteurs prenant part aux recrutements. Nous avions donc besoin d’un outil permettant de centraliser toutes nos campagnes de recrutement et apporter un suivi régulier pour chacune afin de valoriser un maximum l’expérience candidat.',
    img: 'https://www.rhprofiler.com/wp-content/uploads/2019/03/logo-les-3-brasseurs.png',
    name: 'Chloé Fourdin',
    poste: 'RRH'
  }];

  constructor(private encdec: EncryptDecryptService, private http: HttpClient, private httpClient: HttpClient,
    private renderer: Renderer2,
    private eventManager: EventManager,
    private domSanitizer: DomSanitizer) {
    this.eventManager.addGlobalEventListener('window', 'resize', this.OnResize.bind(this));
  }

  ngOnChanges(changes: SimpleChanges) {
    this.charger = !this.charger;

  }

  numberMoins = 100;
  interval: any;
  ngAfterViewInit() {
    this.interval = setInterval(() => {
      this.baseCards.forEach((x, index) => {
        if (!this.actualCards[index])
          this.actualCards.push(0);
        if (this.baseCards[index] && this.actualCards[index] < this.baseCards[index].number) {
          if (this.actualCards[index] === 0 && this.baseCards[index].number > this.numberMoins) {
            this.actualCards[index] += this.baseCards[index].number - this.numberMoins;
          }
          this.actualCards[index] += (this.actualCards[index] + 2 < this.baseCards[index].number ? 2 : this.baseCards[index].number - this.actualCards[index]);
        }
      });
      this.charger = !this.charger
    }, 100)
    this.charger = !this.charger
  }

  private OnResize(event: any) {
    if (window.screen.width >= 1025) {
      this.isMobile = false;
    }
    else
      this.isMobile = true;
    this.charger = !this.charger
    //this.mapComponent.resize();
  }

  ngAfterViewChecked() {
    if (window.screen.width >= 1025) {
      this.isMobile = false;
    }
    else
      this.isMobile = true;
  }

  getSafeHTML(txt) {
    return ConfigService.Sanatizer.bypassSecurityTrustHtml(txt) as string;
  }

  safeCss(style) {
    return this.domSanitizer.bypassSecurityTrustStyle(style);
  }

  ngOnInit(): void {
    this.http.get('https://api.sitederecrutement.com/Home/GetTopAnnonces/' + localStorage.getItem('apikey'), { responseType: "text" }).subscribe(result => {
      if (result.includes('{&quot;Error&quot;:')) {
        console.error(result);
      }
      else {
        const obj = JSON.parse(this.encdec.getDecrypt(result));
        this.annonces = obj;
      }
    }, error => console.error(error));
    this.renderExternalScript('//cdn.jsdelivr.net/npm/velocity-animate@2.0/velocity.min.js').onload = () => {
    }
    this.renderExternalScript('./assets/js/caroussel-1.js').onload = () => {
    }
    clearTimeout(delay);
    var delay = setTimeout(() => this.charger = !this.charger, 1000);
  }

  renderExternalScript(src: string): HTMLScriptElement {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = src;
    script.async = true;
    script.defer = true;
    this.renderer.appendChild(document.body, script);
    return script;
  }
}

interface Slider {
  content: string;
  img: string;
  name: string;
  poste: string;
}

interface AnnonceLite {
  idannonce: number;
  intitule: string;
  emp_adresse1: string;
  emp_code_postal: string;
  emp_ville: string;
  contrats: string;
  societe_adresse: string;
  societe_cp: string;
  societe_ville: string;
  societe_logo: string;
  ref: string;
  previsu: string;
  niveau_formation: string;
  regions: string;
  caract_poste: string;
}

@Pipe({ name: 'functionCaller' })
export class FunctionCallerPipe {
  transform(func: any, ...args: any[]): any {
    return func(...args);
  }
}
